export default class OptionalReprovalFieldsField
  @SELECT_SELECTOR: '#servico_servico_service_type'
  @CONTAINER_SELECTOR: '#optional-reproval-fields-container'
  @CHECKBOX_SELECTOR: '#checkbox-optional-reproval-fields'

  @handler_events: ->
    @sync()

    $(document).off('change.optionalReprovalFields').on 'change.optionalReprovalFields', @SELECT_SELECTOR, =>
      @sync()

  @sync: ->
    select = $(@SELECT_SELECTOR)
    container = $(@CONTAINER_SELECTOR)
    return unless select.length and container.length

    manageable_value = String(container.data('manageable-value'))
    is_manageable = String(select.val()) is manageable_value

    container.toggle(is_manageable)
    $(@CHECKBOX_SELECTOR).prop('checked', false) unless is_manageable
